module.exports = __webpack_public_path__ + "static/media/mountain.f5199300.svg";